// import Login from './Login';
// import Reset from './Reset';

export default [
  {
    path: 'login',
    // component: Login,
    component: load(() => import(/* webpackChunkName: "Login" */ './Login')),
    name: app.translate('routes.Login'),
  },
  {
    path: 'password/reset',
    // component: Reset,
    component: load(() => import(/* webpackChunkName: "Reset" */ './Reset')),
    name: app.translate('routes.Password Reset'),
  },
];
